module.exports = __webpack_public_path__ + "img/corona-variants.336ac02e.png";